/**
 * adminRoutes.jsx — Routes Admin (rôle admin obligatoire).
 *
 * Toutes les routes /admin/* sont protégées par `ProtectedRoute roles=['admin']`
 * et rendues à l'intérieur d'`AdminLayout` (sidebar admin dédié).
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import AdminLayout from '../components/AdminLayout';
import AdminDashboard from '../pages/admin/Dashboard';
import AdminTeacherCodes from '../pages/admin/TeacherCodes';
import AdminTeacherApplications from '../pages/admin/TeacherApplications';
import AdminPasswordResets from '../pages/admin/PasswordResets';
import AdminAnalytics from '../pages/admin/Analytics';
import AdminQuestions from '../pages/admin/Questions';
import AdminAudit from '../pages/admin/Audit';
import AdminCommunity from '../pages/admin/Community';
import AdminAlerts from '../pages/admin/Alerts';
import AdminUsers from '../pages/admin/Users';
import AdminHeroEditions from '../pages/admin/HeroEditions';
import AdminNewsletter from '../pages/admin/Newsletter';
import AdminMailing from '../pages/admin/Mailing';
import AdminProfile from '../pages/admin/Profile';
import AdminContactRequests from '../pages/admin/ContactRequests';
import AdminEmailLogs from '../pages/admin/EmailLogs';
import AdminPayments from '../pages/admin/Payments';
import AdminB2B from '../pages/admin/B2B';
import AdminVoiture from '../pages/admin/Voiture';
import AdminTools from '../pages/admin/Tools';
import AdminInternalRequests from '../pages/admin/InternalRequests';
import AdminAnnuaire from '../pages/admin/Annuaire';
import AnnuairePartenaires from '../pages/admin/AnnuairePartenaires';
import AdminExportPack from '../pages/admin/ExportPack';
import AdminB2BPlaquette from '../pages/admin/B2BPlaquette';
import AdminB2BDocumentsGen from '../pages/admin/B2BDocumentsGen';
import AdminVCardTracking from '../pages/admin/VCardTracking';
import AdminMaCarte from '../pages/admin/MaCarte';
import AdminShortsPage from '../pages/admin/AdminShortsPage';
import BoAdminInboxPage from '../pages/bo/BoAdminInboxPage';

export const AdminRoutes = () => (
  <Route path="/admin" element={
    <ProtectedRoute roles={['admin']}>
      <AdminLayout />
    </ProtectedRoute>
  }>
    <Route index element={<Navigate to="/admin/dashboard" replace />} />
    <Route path="dashboard" element={<AdminDashboard />} />
    <Route path="analytics" element={<AdminAnalytics />} />
    <Route path="teacher-codes" element={<AdminTeacherCodes />} />
    <Route path="teacher-applications" element={<AdminTeacherApplications />} />
    <Route path="password-resets" element={<AdminPasswordResets />} />
    <Route path="questions" element={<AdminQuestions />} />
    <Route path="audit" element={<AdminAudit />} />
    <Route path="community" element={<AdminCommunity />} />
    <Route path="alerts" element={<AdminAlerts />} />
    <Route path="users" element={<AdminUsers />} />
    <Route path="hero-editions" element={<AdminHeroEditions />} />
    <Route path="newsletter" element={<AdminNewsletter />} />
    <Route path="mailing" element={<AdminMailing />} />
    <Route path="profile" element={<AdminProfile />} />
    <Route path="contact-requests" element={<AdminContactRequests />} />
    <Route path="email-logs" element={<AdminEmailLogs />} />
    <Route path="payments" element={<AdminPayments />} />
    <Route path="b2b" element={<AdminB2B />} />
    <Route path="b2b-plaquette" element={<AdminB2BPlaquette />} />
    <Route path="b2b-documents" element={<AdminB2BDocumentsGen />} />
    <Route path="vcard-tracking" element={<AdminVCardTracking />} />
    <Route path="ma-carte" element={<AdminMaCarte />} />
    <Route path="inbox" element={<BoAdminInboxPage />} />
    <Route path="voiture" element={<AdminVoiture />} />
    <Route path="tools" element={<AdminTools />} />
    <Route path="demandes-internes" element={<AdminInternalRequests />} />
    <Route path="annuaire" element={<AdminAnnuaire />} />
    <Route path="annuaire/partenaires" element={<AnnuairePartenaires />} />
    <Route path="annuaire/export" element={<AdminExportPack />} />
    <Route path="shorts" element={<AdminShortsPage />} />
  </Route>
);

export default AdminRoutes;
